// import { useState } from "react";
// import { BASE_URL } from '../apiConfig';
// import { useLanguage } from "../context/LanguageProvider";

// export default function ProductImageGallery({ images, productName }) {
//   const { t } = useLanguage();
//   const [selectedImage, setSelectedImage] = useState(0)

//   return (
//     <div className="space-y-4">
//       <div className="aspect-square overflow-hidden rounded-2xl bg-gray-100">
//         <img
//           src={`${BASE_URL}/storage/${images[selectedImage]?.image || images[0]?.image}`}
//           alt={productName}
//           width={600}
//           height={600}
//           className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
//           priority
//         />
//       </div>

//       {images.length > 1 && (
//         <div className="flex gap-3 overflow-x-auto p-2">
//           {images.map((image, index) => (
//             <button
//               key={image.id}
//               onClick={() => setSelectedImage(index)}
//               className={`flex-shrink-0 cursor-pointer overflow-hidden rounded-lg transition-all duration-200 ${
//                 selectedImage === index ? "ring-2 ring-[var(--color-primary-500)] ring-offset-2" : "hover:opacity-75"
//               }`}
//             >
//               <img
//                 src={`${BASE_URL}/storage/${image.image}`}
//                 alt={`${productName} ${index + 1}`}
//                 width={80}
//                 height={80}
//                 className="h-20 w-20 object-cover"
//               />
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   )
// }

import { useState, useRef } from "react";
import { BASE_URL } from '../apiConfig';
import { useLanguage } from "../context/LanguageProvider";
import { ZoomIn, X } from "lucide-react";

export default function ProductImageGallery({ images, productName, discountValue, isDiscounted }) {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });
  const [isHovering, setIsHovering] = useState(false);
  const imageRef = useRef(null);

  const activeImage = images[selectedImage] || images[0];

  const handleMouseMove = (e) => {
    if (!imageRef.current) return;
    const rect = imageRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoomPosition({ x, y });
  };

  return (
    <div className="flex flex-col-reverse items-start gap-4 md:flex-row">
      {/* Thumbnails */}
      {images.length > 1 && (
        <div className="flex gap-3 overflow-x-auto md:max-h-[470px] md:flex-col md:overflow-x-visible md:overflow-y-auto md:pr-1 thumbnail-scroll custom-scrollbar">
          {images.map((image, index) => (
            <button
              key={image.id}
              onClick={() => setSelectedImage(index)}
              className={`flex-shrink-0 cursor-pointer overflow-hidden rounded-xl border-2 transition-all duration-200 ${
                selectedImage === index
                  ? "border-[var(--color-primary-500)] ring-2 ring-[var(--color-primary-100)]"
                  : "border-transparent hover:border-gray-200"
              }`}
            >
              <img
                src={`${BASE_URL}/storage/${image.image}`}
                alt={`${productName} ${index + 1}`}
                width={72}
                height={72}
                className="object-cover w-16 h-16"
              />
            </button>
          ))}
        </div>
      )}

      {/* Main image */}
      <div
        ref={imageRef}
        className="group relative aspect-square w-full flex-1 overflow-hidden rounded-2xl bg-gray-100 md:max-h-[540px] cursor-zoom-in"
        onMouseMove={handleMouseMove}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        onClick={() => setIsLightboxOpen(true)}
      >
        <img
          src={`${BASE_URL}/storage/${activeImage?.image}`}
          alt={productName}
          height={600}
          width={600}
          className="h-full w-full object-cover transition-transform duration-200 ease-out"
          style={
            isHovering
              ? {
                  transform: "scale(2)",
                  transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
                }
              : { transform: "scale(1)" }
          }
        />

        {isDiscounted && (
          <span className="absolute top-3 right-3 rounded-full bg-green-500 px-3 py-1.5 text-xs font-bold text-white shadow-sm">
            -{discountValue}%
          </span>
        )}

        <div className="absolute bottom-3 right-3 flex items-center gap-1.5 rounded-full bg-black/60 px-3 py-1.5 text-xs font-medium text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
          <ZoomIn size={14} />
          {t('products.click_to_zoom') || 'Cliquer pour zoomer'}
        </div>
      </div>

      {/* Lightbox */}
      {isLightboxOpen && (
        <div
          className="fixed inset-0 z-[99] flex items-center justify-center bg-black/90 p-4"
          onClick={() => setIsLightboxOpen(false)}
        >
          <button
            onClick={() => setIsLightboxOpen(false)}
            className="absolute top-4 right-4 rounded-full bg-white/10 p-2 text-white hover:bg-white/20 transition-colors"
          >
            <X size={24} />
          </button>

          <img
            src={`${BASE_URL}/storage/${activeImage?.image}`}
            alt={productName}
            className="max-h-full max-w-full object-contain cursor-zoom-out"
            onClick={(e) => e.stopPropagation()}
          />

          {images.length > 1 && (
            <div className="absolute bottom-6 left-1/2 flex -translate-x-1/2 gap-2">
              {images.map((image, index) => (
                <button
                  key={image.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedImage(index);
                  }}
                  className={`h-2 w-2 rounded-full transition-all ${
                    selectedImage === index ? "bg-[var(--color-primary-500)] w-6" : "bg-[var(--color-primary-300)]"
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}